import type { ElementKindMap } from '../models/project.model';
import { isOneOf } from './array.helpers';
import { getElementKind } from './recursive-element.helpers';

/**
 * Require the element to be of a specific kind (Element, Version, Product).
 */
export const requiredKind = <K extends keyof ElementKindMap>(
  element: unknown,
  ...kinds: K[]
): ElementKindMap[K] => {
  const elementKind = getElementKind(element);

  if (!kinds.length) {
    throw new Error('No kinds provided');
  }

  if (!isOneOf(kinds, elementKind)) {
    throw new Error(
      `Element kind mismatch. Expected ${kinds.join(' or ')} but got ${elementKind}`,
    );
  }
  return element as ElementKindMap[K];
};
